import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

const appStyle = (theme: Theme) => createStyles({
    "@global": {
        "body": {
            padding: 0,
            margin: 0,
            backgroundColor: [theme.palette.grey["200"], "!important"]
        },
    }
});

export default appStyle;
